<template>
  <div class="bbe-email-thread"
       @click="setMessageOpen(index)"
       :class="{
         'bbe-email-thread_alone': length <= 1 && !replyMode,
         'bbe-email-thread_pointer': checkedCursorPointer(index),
         'bbe-email-thread_no-border': noBorder,
         'bbe-email-thread_first-child': index === 0
       }">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <img class="bbe-email-thread__avatar"
         v-if="length > 1 || replyMode"
         :src="defaultAvatar"/>
    <div class="bbe-email-thread__sender"
         v-if="length > 1 || replyMode">
      {{getSender(index)}}
    </div>
    <div class="bbe-email-thread__snippet"
         v-html="getSnippet(index)"
         v-if="!openMessages[index]"/>
    <div class="bbe-email-thread__mark">
      <MarkMessageAs v-if="!loaderRun"
                     @setOption="updateTrackingMail"
                     :defaultValues="statusMessage"/>
    </div>
    <div class="bbe-email-thread__date">
      {{getDate(index)}}
    </div>
    <div
      v-if="openMessages[index]"
      class="bbe-email-thread__message"
      v-html="msg"
      @click.stop
    />
  </div>
</template>

<script>
import defaultAvatar from '@/assets/images/user.png'
import {get, trim, debounce, isEmpty} from 'lodash'
import moment from 'moment'
import MarkMessageAs from '@/components/Main/MarkMessageAs/MarkMessageAs'
import EmailStatsApi from '@/api/EmailStats/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import updateEmailStatus from '@/mixin/updateEmailStatus'

export default {
  name: 'EmailThread',
  components: {
    MarkMessageAs,
    LoaderFly
  },
  mixins: [updateEmailStatus],
  props: ['msg', 'index', 'length', 'noBorder', 'replyMode'],
  data () {
    return {
      loaderRun: false,
      statusMessage: {},
      openMessages: [true],
      defaultAvatar: defaultAvatar
    }
  },
  computed: {
    messageId () {
      return get(this.activeEmail, ['messages', this.index, 'id'], '')
    },
    activeEmail () {
      return this.$store.getters.activeEmail
    },
    updateTrackingMail () {
      return debounce(this.changeTrackingMessage, 1000)
    }
  },
  methods: {
    getEmailStatus () {
      this.loaderRun = true
      EmailStatsApi.getEmailById({messageId: this.messageId})
        .then(({data}) => {
          this.loaderRun = false
          this.statusMessage = data
          this.activeEmail.$statusMessage = data
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    },
    changeTrackingMessage (reason) {
      if (isEmpty(reason)) return
      const body = {
        messageId: this.statusMessage.messageId,
        status: 3,
        excludedReason: reason.id
      }
      EmailStatsApi.updateEmailStatus(body)
        .then(({data}) => {
          this.removeJobNotification(data)
          this.statusMessage = data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getSender (index) {
      return get(this.activeEmail, `messages[${index}]info.from.name`, '')
    },
    getSnippet (index) {
      return get(this.activeEmail, `messages[${index}]info.snippet`, '')
    },
    getDate (index) {
      const date = get(this.activeEmail, `messages[${index}]info.date`, '')
      return moment(date).format('DD-MMM-YY, HH:mm:ss')
    },
    setMessageOpen (index) {
      const firstMsg = index === 0 && !this.replyMode
      const shortContent = !this.isLongContent(index)
      if ((this.length === 1 || firstMsg || shortContent) && !this.replyMode) return
      if (this.openMessages[index]) {
        this.$set(this.openMessages, index, false)
      } else {
        this.$set(this.openMessages, index, true)
      }
    },
    isLongContent (index) {
      const div = document.createElement('div')
      div.innerHTML = this.msg
      const text = div.textContent || div.innerText || ''
      const tags = this.msg.includes('src') || this.msg.includes('table')
      return trim(text) !== this.getSnippet(index) || tags
    },
    checkedCursorPointer (index) {
      return !this.openMessages[index] && this.isLongContent(index)
    }
  },
  watch: {
    messageId () {
      // this.getEmailStatus()
    }
  },
  beforeMount () {
    // this.getEmailStatus()
    this.openMessages[0] = !this.replyMode
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-email-thread {
  display: grid;
  grid-template-columns: 54px 1fr auto 110px;
  border-top: 1px solid $color-wild-sand;
  padding: 17px 0;

  &_alone {
    grid-template-columns: 0 1fr auto 110px;
  }

  &_pointer {
    cursor: pointer;
  }
  &_no-border {
    border-top: none;
  }

  &_first-child {
    border-top: none;
    //padding: 0 0 17px;
  }

  &__avatar {
    grid-row: 1/3;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    object-fit: contain;
    margin-right: 12px;
    user-select: none;
  }

  &__sender {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 7px;
  }

  &__snippet {
    text-overflow: ellipsis;
    color: $color-silver-chalice;
  }

  &__mark {
    grid-column: 3;
    grid-row: 1;
  }

  &__date {
    justify-self: end;
    grid-row: 1;
    grid-column: 4;
    font-size: 12px;
    line-height: 14px;
    color: $color-silver-chalice;
  }

  &__message, &__snippet {
    margin-top: 21px;
    grid-column: 2/end;
    color: $color-text-message;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.4;
    overflow: hidden;

    i {
      font-style: italic;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailThread/EmailThread.vue